import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import ActivityWrap from "./style";
import { Button, Nav, Tab, ListGroup } from "react-bootstrap";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import BarLoader from "react-spinners/ClipLoader";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { ConfirmationBox } from "../../../../Reuseable/ConfimationBox";
import { WysiwygEditor } from "../../../../Reuseable/WysiwygEditor";
import { api } from "../../../../../Services/api";
import { setAllTrackings } from "../../../../../redux/Tracking/actionCreator";
import { useFetch } from "../../../../../Hooks/useFetch";
import { key } from "../../../../../data/queryKeys";
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML,
} from "draft-js";

export const Activity = ({ item, history, data }) => {
  const dispatch = useDispatch();
  const allTrackingsList = useSelector((state) => state.Tracking.allTrackings);
  const myTrackingList = useSelector((state) => state.Tracking.myTrackings);
  const allFlowStatus = useSelector((state) => state.Tracking.allFlowStatus);
  // const allMembers = useSelector((state) => state.Tracking.allMembers);
  const trackingClientId = useSelector(
    (state) => state.Auth.user.trackingclientid,
  );
  let [getTaggedUsers, setgetTaggedUsers] = useState([]);
  const urlParams = new URLSearchParams(window.location.search);
  const path = window.location.pathname;
  const pageName = path.split("/").pop();
  console.log(pageName, "pageNamepageName");

  const { data: allTasksTypesRes } = useFetch(
    key.get_all_tasktypes,
    "/trackingtasktype",
    () => {},
    () => {},
    false,
    true,
  );
  let allTaskTypes = allTasksTypesRes?.data ?? [];

  const { data: allProjectMembers } = useFetch(
    key.get_all_members,
    `/trackingusers/memberlist/${trackingClientId}`,
    () => {},
    () => {},
    false,
    false,
  );
  let allMembers = allProjectMembers?.data ?? [];

  const [commentEditor, setCommentsEditor] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [comment, setComment] = useState("");
  const [updatedComment, setUpdatedComment] = useState("");
  const [commentsList, setCommentsList] = useState(item.comments);
  const [showEdit, setShowEdit] = useState(false);

  const userid = useSelector((state) => state.Auth.user.trackinguserid);
  const authToken = useSelector((state) => state.Auth.authToken);
  const [selectedComment, setSelectedComment] = useState("");
  const index = allTrackingsList.findIndex(
    (element) => element.trackingid === item.trackingid,
  );
  const myTaskIndex = myTrackingList.findIndex(
    (element) => element.trackingid === item.trackingid,
  );
  const [loading, setLoading] = useState(false);
  const [searchedMembers, setSearchedMembers] = useState([]);
  const [changed, setChanged] = useState(false);
  const [showList, setShowList] = useState(false);
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const commentRef = useRef();

  useEffect(() => {
    var regex = /@/gi,
      result = [];
    let users = [];
    while ((result = regex.exec(comment))) {
      users.push(result);
    }
    if (users.length > 0) {
      setChanged(false);
      setShowList(true);
      setSearchedMembers(
        allMembers?.filter((item) => {
          return (
            item?.personname?.toLowerCase().includes(
              comment
                ?.toLowerCase()
                ?.slice(users[users.length - 1]?.index + 1)
                .trim()
                .replace("</p>", ""),
            ) ||
            item?.trackinguserid?.toLowerCase().includes(
              comment
                ?.toLowerCase()
                ?.slice(users[users.length - 1]?.index + 1)
                .trim()
                .replace("</p>", ""),
            )
          );
        }),
      );
    } else {
      setShowList(false);
    }
  }, [comment]);

  // eslint-disable-next-line no-extend-native
  String.prototype.replaceAt = function (index, replacement) {
    return this.substring(0, index) + replacement + " </p>";
  };

  const selectTaggedUser = (name, comment) => {
    var str = comment;

    let users = [];
    var regex = /@/gi;
    var result = [];

    while ((result = regex.exec(comment))) {
      users.push(result);
    }

    if (users.length > 0) {
      const lastIndex = users[users.length - 1].index;
      setComment(str.replaceAt(lastIndex + 1, name) + "");
    }

    setChanged(true);
    setShowList(false);
  };
  const loaderstyle = {
    background: loading ? "#FFFFFF" : "#f1f1f1",
    color: loading ? "#808080" : "#9d9d9d",
    border: loading ? "2px solid #FFFFFF" : "2px solid #d3d3d3",
    borderColor: loading ? "FFFFFF" : "#d3d3d3",
  };
  let his = [];

  if (history) {
    for (let i = history.length; i > 0; i--) {
      his.push(history[i - 1]);
    }
  }

  const onDeleteHandler = (response) => {
    if (response) {
      api
        .delete(
          "/tracking/" + trackingClientId + "/" + item.trackingid + "/comment",
          {
            headers: {
              authorizationtoken: `${authToken}`,
            },
            data: {
              cid: selectedComment,
            },
          },
        )
        .then((response) => {
          setLoading(false);
          setCommentsList(response.data.data.comments ?? {});
          if (index !== -1 || index === 0) {
            allTrackingsList[index].comments =
              response.data.updatedData.comments;
            dispatch(setAllTrackings([...allTrackingsList]));
          }
          if (myTaskIndex !== -1 || myTaskIndex === 0) {
            myTrackingList[myTaskIndex].comments =
              response.data.updatedData.comments;
          }
          setCommentsEditor(false);
        })
        .catch((error) => {
          return error;
        });
    }
  };
  const updateComment = (id) => {
    setLoading(true);
    api
      .patch(
        "/tracking/" + trackingClientId + "/" + item.trackingid + "/comment",
        {
          cid: id,
          comment: updatedComment,
          timezone: timezone,
        },
        {
          headers: {
            authorizationtoken: `${authToken}`,
          },
        },
      )
      .then((response) => {
        setLoading(false);
        setComment("");
        setShowEdit(false);
        setCommentsList(response.data.updatedData.comments);
        if (index !== -1 || index === 0) {
          allTrackingsList[index].comments = response.data.updatedData.comments;
          dispatch(setAllTrackings([...allTrackingsList]));
        }
        if (myTaskIndex !== -1 || myTaskIndex === 0) {
          myTrackingList[myTaskIndex].comments =
            response.data.updatedData.comments;
        }
        setCommentsEditor(false);
      })
      .catch((error) => {
        return error;
      });
  };

  const saveComment = (comment) => {
    let users = allMembers.filter((item) => {
      return comment.toLowerCase().includes(userid.toLowerCase());
    });
    setLoading(true);
    api
      .post(
        "/tracking/" + trackingClientId + "/" + item.trackingid + "/comment",
        {
          comment: comment,
          timezone: timezone,
          taggedUsers: getTaggedUsers.length === 0 ? users : getTaggedUsers,
          taskStatus:
            pageName === "Re Open" ||
            pageName === "Failed" ||
            pageName === "reopen" ||
            pageName === "failed"
              ? "reopen"
              : "",
        },
        {
          headers: {
            authorizationtoken: `${authToken}`,
          },
        },
      )
      .then((response) => {
        if (response.data.status) {
          setLoading(false);
          setComment("");
          setgetTaggedUsers([]);
          setCommentsList(response.data.updatedData.comments);
          setCommentsEditor(false);
          if (index !== -1 || index === 0) {
            allTrackingsList[index].comments =
              response.data.updatedData.comments;
            dispatch(setAllTrackings([...allTrackingsList]));
          }
          if (myTaskIndex !== -1 || myTaskIndex === 0) {
            myTrackingList[myTaskIndex].comments =
              response.data.updatedData.comments;
          }
        } else return response.data.message;
      })
      .catch((error) => {
        return error;
      });
  };

  useEffect(() => {
    if (commentEditor) {
      commentRef.current.focusEditor();
    }
  }, [commentEditor]);

  return (
    <ActivityWrap>
      <div className="text-start mt-5 p-2 my-3">
        <strong className="tr-color">Activity</strong>
        <Tab.Container id="left-tabs-example" defaultActiveKey="comments">
          <Nav variant="pills" className="mt-2">
            <Nav.Item>
              <Nav.Link eventKey="comments">Comments</Nav.Link>
            </Nav.Item>
            <Nav.Item className="ms-2">
              <Nav.Link eventKey="history">History</Nav.Link>
            </Nav.Item>
          </Nav>
          <Tab.Content className="mt-3">
            <Tab.Pane eventKey="comments">
              {commentEditor ? (
                <div className="mb-4 editor-section position-relative">
                  <WysiwygEditor
                    editorRef={commentRef}
                    handleReturn={(e, comm) => {
                      if (e.keyCode === 13) {
                        e.preventDefault();
                        saveComment(comm);
                        setCommentsEditor(false);
                      }
                    }}
                    value={comment}
                    onChange={(value) => {
                      setComment(value);
                    }}
                    changed={changed}
                    hideToolbar={true}
                  />
                  {comment != "" &&
                  comment != undefined &&
                  searchedMembers.length > 0 &&
                  showList ? (
                    <ListGroup
                      style={{
                        position: "absolute",
                        width: "50%",
                        overflow: "hidden",
                        overflowY: "auto",
                        height: 165,
                        marginTop: -50,
                      }}
                    >
                      {searchedMembers.length > 0 ? (
                        <>
                          {searchedMembers.map((item, index) => {
                            return (
                              <ListGroup.Item
                                variant="secondary"
                                style={{ cursor: "pointer" }}
                                key={index}
                                onClick={(e) => {
                                  selectTaggedUser(item.personname, comment);
                                  let getUserId = allMembers.find(
                                    (emailId) =>
                                      emailId.personname === item.personname,
                                  );
                                  setgetTaggedUsers((prevTaggedUsers) => {
                                    if (
                                      !prevTaggedUsers.includes(
                                        getUserId.userId,
                                      )
                                    ) {
                                      return [
                                        ...prevTaggedUsers,
                                        getUserId.userId,
                                      ];
                                    } else {
                                      return prevTaggedUsers;
                                    }
                                  });
                                  setSearchedMembers([]);
                                }}
                              >
                                {item.personname}
                                <br />
                                <small>{item.trackinguserid}</small>
                              </ListGroup.Item>
                            );
                          })}
                        </>
                      ) : (
                        ""
                      )}
                    </ListGroup>
                  ) : (
                    <></>
                  )}
                  <div className="text-end">
                    <Button
                      size="sm"
                      sx={{ display: "flex", alignItems: "center" }}
                      variant="secondary"
                      style={loaderstyle}
                      className="titleupdate me-1 ps-3 pe-3 border-none"
                      disabled={
                        comment === "" || comment.length === 8 ? true : false
                      }
                      onClick={(e) => saveComment(comment)}
                    >
                      {loading ? (
                        <BarLoader
                          color="#808080"
                          className="bar-loader"
                          size={14}
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        <></>
                      )}
                      <CheckIcon />
                      {""}
                    </Button>
                    <Button
                      size="sm"
                      variant="secondary"
                      className="titlecancel ps-3 pe-3  border-none"
                      onClick={(e) => {
                        setCommentsEditor(false);
                        setComment("");
                        setgetTaggedUsers([]);
                      }}
                    >
                      <CloseIcon />
                    </Button>
                  </div>
                </div>
              ) : !showEdit ? (
                <div className="add-comment">
                  <input
                    type="text"
                    placeholder="Add a comment..."
                    disabled={window.location.pathname.includes("archive")}
                    style={{
                      cursor: window.location.pathname.includes("archive")
                        ? "not-allowed"
                        : "text",
                    }}
                    className="form-control mb-4"
                    onClick={(e) => {
                      setCommentsEditor(true);
                      setShowEdit(false);
                    }}
                  />
                </div>
              ) : (
                ""
              )}

              {Object.keys(commentsList || {}) // Ensure commentsList is an object
                .sort((item1, item2) =>
                  item1.datetime < item2.datetime ? 1 : -1,
                )
                .map((key) => {
                  let item = commentsList[key];
                  return (
                    <div className="mt-3" key={key}>
                      <div className="d-flex">
                        <div className="flex-shrink-0">
                          <span className="imgfirstLetr text-capitalize">
                            {" "}
                            {item.personname[0]}
                          </span>
                        </div>
                        <div className="flex-grow-1 ms-3">
                          <div className="comments-section">
                            <div className="mb-2">
                              <span className="me-3">
                                <strong>{item.personname}</strong>
                              </span>
                              <span>{item.datetime}</span>
                            </div>
                            <div className="editCommentPart position-relative">
                              {showEdit && selectedComment === key ? (
                                <>
                                  <WysiwygEditor
                                    value={item.comment}
                                    onChange={(value) =>
                                      setUpdatedComment(value)
                                    }
                                    changed={changed}
                                    hideToolbar={true}
                                  />
                                  <div className="text-end">
                                    <Button
                                      size="sm"
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                      variant="secondary"
                                      style={loaderstyle}
                                      className="titleupdate me-1 ps-3 pe-3 border-none"
                                      disabled={
                                        updatedComment === "" ||
                                        updatedComment.length === 8
                                          ? true
                                          : false
                                      }
                                      onClick={(e) => updateComment(key)}
                                    >
                                      {loading ? (
                                        <BarLoader
                                          color="#808080"
                                          className="bar-loader"
                                          size={14}
                                          role="status"
                                          aria-hidden="true"
                                        />
                                      ) : (
                                        <></>
                                      )}
                                      <CheckIcon />
                                      {""}
                                    </Button>
                                    <Button
                                      size="sm"
                                      variant="secondary"
                                      className="titlecancel ps-3 pe-3  border-none"
                                      onClick={(e) => setShowEdit(false)}
                                    >
                                      <CloseIcon />
                                    </Button>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <p className="mt-2 mb-1">
                                    <small
                                      dangerouslySetInnerHTML={{
                                        __html: item.comment,
                                      }}
                                    />{" "}
                                  </p>
                                  {userid === item.trackinguserid ? (
                                    <p>
                                      <Button
                                        style={{ color: "#4EB6EE" }}
                                        variant="link"
                                        size="sm"
                                        onClick={(e) => {
                                          setShowEdit(true);
                                          setCommentsEditor(false);
                                          setSelectedComment(key);
                                          setUpdatedComment(item.comment);
                                        }}
                                      >
                                        <EditIcon />
                                      </Button>
                                      <Button
                                        style={{ color: "#4EB6EE" }}
                                        variant="link"
                                        size="sm"
                                        onClick={(e) => {
                                          setShowDelete(true);
                                          setSelectedComment(key);
                                        }}
                                      >
                                        <DeleteIcon />{" "}
                                      </Button>
                                    </p>
                                  ) : (
                                    <></>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </Tab.Pane>
            <Tab.Pane eventKey="history">
              {his?.map((value, index) => {
                return (
                  <div key={index}>
                    {Object.keys(value?.actions)?.map((action, index1) => {
                      let personName = value?.personname ?? "";

                      const getMemberName = (id) => {
                        if (!id) return "None";
                        const member = allMembers.find((e) => e.userId === id);
                        if (member && member.personname)
                          return member.personname;
                      };

                      const getTaskType = (id) => {
                        if (!id) return "None";
                        const type = allTaskTypes.find(
                          (e) => String(e.id) === String(id),
                        );
                        return type?.label || "None";
                      };

                      const getStatusLabel = (id) => {
                        if (!id) return "None";
                        const statusList = Array.isArray(data?.status_list)
                          ? data.status_list
                          : []; // Ensure statusList is an array
                        const status = statusList.find(
                          (e) => String(e.id) === String(id),
                        );

                        return status?.label || id || "";
                      };

                      return (
                        <div key={index1} className="mb-3">
                          <div className="d-flex">
                            <div className="flex-shrink-0">
                              <span className="imgfirstLetr text-capitalize">
                                {personName[0]}
                              </span>
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <div className="history-section ps-0">
                                <div>
                                  {/* Action message */}
                                  {action === "status_changed" && (
                                    <p>
                                      <strong>{personName}</strong> changed the
                                      status from{" "}
                                      <strong>
                                        {getStatusLabel(
                                          value.actions[action].previous_status,
                                        )}
                                      </strong>{" "}
                                      to{" "}
                                      <strong>
                                        {getStatusLabel(
                                          value.actions[action].currentStatus,
                                        )}
                                      </strong>{" "}
                                      <span className="ms-3">
                                        {value.datetime}
                                      </span>
                                    </p>
                                  )}

                                  {action === "assignedto_changed" && (
                                    <p>
                                      <strong>{personName}</strong> reassigned
                                      the task from{" "}
                                      <strong>
                                        {getMemberName(
                                          value.actions[action].previous_status,
                                        )}
                                      </strong>{" "}
                                      to{" "}
                                      <strong>
                                        {getMemberName(
                                          value.actions[action].current_status,
                                        )}
                                      </strong>{" "}
                                      <span className="ms-3">
                                        {value.datetime}
                                      </span>
                                    </p>
                                  )}

                                  {action === "created_new" && (
                                    <p>
                                      <strong>{personName}</strong> created a
                                      new task{" "}
                                      <span className="ms-3">
                                        {value.datetime}
                                      </span>
                                    </p>
                                  )}

                                  {action === "timeline_changed" && (
                                    <p>
                                      <strong>{personName}</strong> updated the
                                      timeline from{" "}
                                      <strong>
                                        {value.actions[action].previous_status
                                          ? `${value.actions[action].previous_status} hours`
                                          : "None"}
                                      </strong>{" "}
                                      to{" "}
                                      <strong>{`${value.actions[action].currentStatus} hours`}</strong>{" "}
                                      <span className="ms-3">
                                        {value.datetime}
                                      </span>
                                    </p>
                                  )}

                                  {action === "priority_changed" && (
                                    <p>
                                      <strong>{personName}</strong> changed the
                                      priority from{" "}
                                      <strong>
                                        {value.actions[action]
                                          .previous_status || "None"}
                                      </strong>{" "}
                                      to{" "}
                                      <strong>
                                        {value.actions[action].current_status}
                                      </strong>{" "}
                                      <span className="ms-3">
                                        {value.datetime}
                                      </span>
                                    </p>
                                  )}

                                  {action === "type_changed" && (
                                    <p>
                                      <strong>{personName}</strong> changed the
                                      task type from{" "}
                                      <strong>
                                        {getTaskType(
                                          value.actions[action].previous_status,
                                        )}
                                      </strong>{" "}
                                      to{" "}
                                      <strong>
                                        {getTaskType(
                                          value.actions[action].current_status,
                                        )}
                                      </strong>{" "}
                                      <span className="ms-3">
                                        {value.datetime}
                                      </span>
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
      <ConfirmationBox
        heading={"Are you sure to delete?"}
        hidePopup={(e) => setShowDelete(false)}
        show={showDelete}
        confirmationResponse={onDeleteHandler}
      />
    </ActivityWrap>
  );
};
